import React, { useState, useEffect } from "react";
import { Link, useParams, Prompt } from "react-router-dom";
import {
  fetchOne,
  fetchOneWithPopulates,
  fetchAll,
} from "../utils/fetchResources";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { onReadyCKE, CKEconfig } from "../config/CKE";
import SetFile from "../components/SetFile";
import {
  Typography,
  Switch,
  FormGroup,
  FormControl,
  InputLabel,
  Input,
  FormControlLabel,
  MenuItem,
  Select,
  Grid,
  Button,
  TextField,
  Hidden,
  Card,
  CardContent,
  useTheme,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(2, 0, 1),
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
}));

export default function EntriesEdit(props) {
  const theme = useTheme();
  const { id } = useParams();
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [loadingCurSite, setLoadingCurSite] = useState(true);
  const [currentSite, setCurrentSite] = useState();
  const [entry, setEntry] = useState({
    relatedEntries: [],
    relatedPeople: [],
    published: false,
  });
  const [populatedEntry, setPopulatedEntry] = useState();
  const [existingEntries, setExistingEntries] = useState();
  const [existingPeople, setExistingPeople] = useState();
  const [themes, setThemes] = useState([]);
  const [regions, setRegions] = useState([]);
  const [units, setUnits] = useState([]);
  const [publicLink, setPublicLink] = useState();
  const [unsaved, setUnsaved] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const fetchPublicLink = async (id) => {
    try {
      let res = await fetch(
        `${process.env.REACT_APP_API_URL}/entries?_id=${id}`,
        {
          credentials: "include",
        }
      );
      res = await res.json();
      if (res.success) {
        if (res.data[0].unit && Object.keys(res.data[0].unit).length !== 0) {
          setPublicLink(
            `/${res.data[0].unit.site.slug}/entries/${res.data[0].slug}`
          );
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    const fetchEverything = async () => {
      await fetchOneWithPopulates("entries", id, setPopulatedEntry);
      await fetchOne("entries", id, setEntry);
      await fetchAll("people", setExistingPeople, "lastName");
      await fetchAll("entries", setExistingEntries, "title");
      await fetchAll("themes", setThemes, "name");
      await fetchAll("regions", setRegions, "name");
      await fetchAll("units", setUnits, "name");
      await fetchPublicLink(id);
      setLoading(false);
    };
    fetchEverything();
  }, [id]);

  useEffect(() => {
    console.log("populatedEntry", populatedEntry);
  }, [populatedEntry]);

  const onChange = (e) => {
    console.log(e.target.name, e.target.value);
    setEntry({ ...entry, [e.target.name]: e.target.value });
    setUnsaved(true);
  };

  const onChangeCKE = (e, editor, fieldName) => {
    const data = editor.getData();
    setEntry({ ...entry, [fieldName]: data });
    setUnsaved(true);
  };

  const onChangePublished = (event) => {
    setEntry({ ...entry, [event.target.name]: event.target.checked });
    setUnsaved(true);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    ////Remove any keys with an empty str as the value
    //for (const key of Object.keys(entry)) {
    //	if (entry[key] === "") {
    //		delete entry[key];
    //	}
    //}

    if (!entry.unit) {
      return enqueueSnackbar("Unit field is required", { variant: "error" });
    }

    fetch(`${process.env.REACT_APP_API_URL}/entries/${id}`, {
      method: "PUT",
      credentials: "include",
      body: JSON.stringify(entry),
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setUnsaved(false);
          enqueueSnackbar("Entry updated successfully!", {
            variant: "success",
          });
          fetchPublicLink(id);
        } else {
          console.log(data);
          const errorArray = data.error.split(",");
          errorArray.forEach((error) => {
            enqueueSnackbar(`${error}`, { variant: "error" });
          });
        }
      });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Prompt
        when={unsaved}
        message="You have unsaved changes. Are you sure you want to leave?"
      />
      <Typography component="h1" variant="h4">
        {`Edit Entry: `}
        {publicLink ? (
          <Link
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: theme.palette.primary.main }}
            to={publicLink}
          >
            {entry.title}
          </Link>
        ) : (
          entry.title
        )}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={9}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="title"
            label="Entry's Title"
            name="title"
            size="small"
            value={entry.title}
            autoFocus
            required
            onChange={onChange}
          />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl
                fullWidth
                className={classes.formControl}
                size="medium"
                margin="normal"
              >
                <InputLabel id="relatedPeopleLabel">Related People</InputLabel>
                <Select
                  inputProps={{ name: "relatedPeople" }}
                  labelId="relatedPeople"
                  id="relatedPeople"
                  multiple
                  value={entry.relatedPeople}
                  onChange={onChange}
                  input={<Input />}
                  disabled={existingPeople.length === 0}
                  renderValue={() => "View Selected"}
                >
                  {existingPeople &&
                    existingPeople.map((person) => {
                      const fullName = (person) => {
                        let name = "";
                        if (person.firstName) {
                          name += person.firstName;
                        }
                        if (person.middleName) {
                          name += " " + person.middleName;
                        }
                        if (person.lastName) {
                          name += " " + person.lastName;
                        }
                        if (person.suffix) {
                          name += " " + person.suffix;
                        }
                        if (person.title) {
                          name += ", " + person.title;
                        }
                        return name;
                      };
                      return (
                        <MenuItem key={person} value={person._id}>
                          {fullName(person)}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl
                fullWidth
                className={classes.formControl}
                size="medium"
                margin="normal"
              >
                <InputLabel id="relatedEntriesLabel">
                  Related Entries
                </InputLabel>
                <Select
                  inputProps={{ name: "relatedEntries" }}
                  labelId="relatedEntries"
                  id="relatedEntries"
                  multiple
                  value={entry.relatedEntries}
                  onChange={onChange}
                  renderValue={() => "View Selected"}
                  disabled={
                    existingEntries
                      .filter(
                        (eachEntry) =>
                          populatedEntry.unit.site._id ===
                          eachEntry.unit.site._id
                      )
                      .filter((eachEntry) => entry.title !== eachEntry.title)
                      .length === 0
                  }
                >
                  {existingEntries &&
                    existingEntries
                      .filter(
                        (eachEntry) =>
                          populatedEntry.unit.site._id ===
                          eachEntry.unit.site._id
                      )
                      .filter((eachEntry) => eachEntry.title !== entry.title)
                      .map((entry) => (
                        <MenuItem key={entry} value={entry._id}>
                          {entry.title}
                        </MenuItem>
                      ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Description:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            data={entry.description || ""}
            editor={Editor}
            onChange={(e, editor) => onChangeCKE(e, editor, "description")}
            config={CKEconfig("Entry's short description...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Historical Background:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            data={entry.historicalBackground || ""}
            editor={Editor}
            onChange={(e, editor) => {
              onChangeCKE(e, editor, "historicalBackground");
            }}
            config={CKEconfig("Entry's historical background...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Citation Text:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            data={entry.citationText || ""}
            editor={Editor}
            onChange={(e, editor) => {
              onChangeCKE(e, editor, "citationText");
            }}
            config={CKEconfig("Citation text...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Repository:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            data={entry.repository || ""}
            editor={Editor}
            onChange={(e, editor) => onChangeCKE(e, editor, "repository")}
            config={CKEconfig("Repository...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Links:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            data={entry.links || ""}
            editor={Editor}
            onChange={(e, editor) => onChangeCKE(e, editor, "links")}
            config={CKEconfig("Links...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            For Educators:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            data={entry.forEducators || ""}
            editor={Editor}
            onChange={(e, editor) => onChangeCKE(e, editor, "forEducators")}
            config={CKEconfig("For educators...")}
          />
          <Typography style={{ marginTop: "1.5rem", fontWeight: "bold" }}>
            Suggested Reading:
          </Typography>
          <CKEditor
            onReady={(editor) => {
              onReadyCKE(editor);
            }}
            data={entry.suggestedReading || ""}
            editor={Editor}
            onChange={(e, editor) => onChangeCKE(e, editor, "suggestedReading")}
            config={CKEconfig("Suggested reading...")}
          />
          <Button
            type="submit"
            onClick={onSubmit}
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Save
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Card>
            <CardContent>
              <Hidden smDown>
                <Button
                  type="submit"
                  onClick={onSubmit}
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Save
                </Button>
              </Hidden>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                      checked={entry.published}
                      onChange={onChangePublished}
                      name="published"
                    />
                  }
                  label={
                    entry.published ? (
                      <Typography color="primary">Published</Typography>
                    ) : (
                      <Typography color="secondary">Draft</Typography>
                    )
                  }
                />
              </FormGroup>
              <SetFile
                fileTitle="Featured Image"
                resource={entry}
                setResource={setEntry}
                imageOnly={true}
                fileLabel="featuredImage"
                fileLabelFileName="featuredImageFile"
              />
              <SetFile
                fileTitle="High Res"
                resource={entry}
                setResource={setEntry}
                imageOnly={false}
                fileLabel="hires"
                fileLabelFileName="hiresFile"
              />
              <SetFile
                fileTitle="Transcription"
                resource={entry}
                setResource={setEntry}
                imageOnly={false}
                fileLabel="transcription"
                fileLabelFileName="transcriptionFile"
              />
              <FormControl
                fullWidth
                size="medium"
                margin="normal"
                className={classes.formControl}
                required
              >
                <InputLabel id="unit-label">Unit</InputLabel>
                <Select
                  inputProps={{ name: "unit" }}
                  value={entry.unit ?? ""}
                  onChange={onChange}
                  label="unit"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {units &&
                    units
                      .filter(
                        (unit) => unit.site._id === populatedEntry.unit.site._id
                      )
                      .map((unit, index) => {
                        return (
                          <MenuItem key={index} value={unit._id}>
                            {unit.name}
                          </MenuItem>
                        );
                      })}
                </Select>
              </FormControl>
              {entry.unit && (
                <>
                  <FormControl fullWidth size="medium">
                    <InputLabel id="regions-input-label">Themes</InputLabel>
                    <Select
                      multiple
                      name="themes"
                      value={entry.themes ?? []}
                      onChange={onChange}
                      input={<Input id="themes" />}
                    >
                      {themes &&
                        themes
                          .filter(
                            (theme) =>
                              theme.site._id === populatedEntry.unit.site._id
                          )
                          .map((theme) => (
                            <MenuItem key={theme._id} value={theme._id}>
                              {theme.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                  {
                      regions && regions.filter((region) => region.site._id === populatedEntry.unit.site._id).length > 0 &&
                  <FormControl fullWidth size="medium">
                    <InputLabel id="regions-input-label">Regions</InputLabel>
                    <Select
                      multiple
                      name="regions"
                      value={entry.regions ?? []}
                      onChange={onChange}
                      input={<Input id="regions" />}
                    >
                      {regions &&
                        regions
                          .filter(
                            (region) =>
                              region.site._id === populatedEntry.unit.site._id
                          )
                          .map((region) => (
                            <MenuItem key={region._id} value={region._id}>
                              {region.name}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                  }
                </>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
